module.exports = __webpack_public_path__ + "img/nibnut.2966751e.png";